//  Copyright (c) 2019 First Foundry Inc. All rights reserved.

const PATH = 'auth'
export const AUTH_TOKEN = `${PATH}/token`
export const LOGOUT = `${PATH}/logout`
